export const useUncompletedChecklists = () => {
  const user = useUserStore()
  const customFieldStore = useCustomFieldStore()
  const checklistStore = useChecklistStore()
  const { fetchAllEventTasksForDate } = useEvents()
  const customFields = ref(customFieldStore.getData() ?? {})
  const uncompletedChecklistsCount = computed(() => checklistStore.count)
  const isLoading = computed(() => checklistStore.isLoading)

  const countUncompletedChecklists = async () => {
    if (!user.isLoggedIn) {
      checklistStore.setCount(0)
      return
    }

    try {
      checklistStore.setLoading(true)
      const today = new Date()

      const tasksByEventId = await fetchAllEventTasksForDate(today)

      let totalUncompleted = 0
      for (const eventId in tasksByEventId) {
        const tasks = tasksByEventId[eventId]

        for (const task of tasks) {
          if (task.task_checklist && task.task_checklist.length > 0) {
            const uncompletedInTask = task.task_checklist.filter(
              (checklist: any) => checklist.done === 0
            ).length
            totalUncompleted += uncompletedInTask
          }
        }
      }

      checklistStore.setCount(totalUncompleted)
    } catch (error) {
      checklistStore.setCount(0)
    } finally {
      checklistStore.setLoading(false)
    }
  }

  watch(
    () => customFieldStore.getData(),
    (newData) => {
      if (newData) {
        customFields.value = newData ?? {}
      }
    },
    { immediate: true }
  )

  return {
    uncompletedChecklistsCount,
    isLoading,
    countUncompletedChecklists
  }
}
